/**
 * Pre-compiled localized messages for TagGroup component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import tagGroupMessages_en from "./intl/en";
import tagGroupMessages_de from "./intl/de";
import tagGroupMessages_es from "./intl/es";
import tagGroupMessages_fr from "./intl/fr-FR";
import tagGroupMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const tagGroupMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(tagGroupMessages_en),
  de: normalizeMessages(tagGroupMessages_de),
  es: normalizeMessages(tagGroupMessages_es),
  "fr-FR": normalizeMessages(tagGroupMessages_fr),
  "pt-BR": normalizeMessages(tagGroupMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for TagGroup component
 */
export type TagGroupMessageKey = "removeTag";
